<template>
  <div class="profile">
    <div class="image preview">
      <img class="preview__image" :src="profileData.photoURL" />
    </div>
    <dl class="profile__confirm">
      <div v-if="profileData.email">
        <dt class="profile__confirm__dt">メールアドレス</dt>
        <dd class="profile__confirm__dd">{{ profileData.email }}</dd>
      </div>
      <dt class="profile__confirm__dt">ニックネーム</dt>
      <dd class="profile__confirm__dd">{{ profileData.nickname }}</dd>
      <dt class="profile__confirm__dt">生年月日</dt>
      <dd class="profile__confirm__dd">{{ birthDateString }}</dd>
      <dt class="profile__confirm__dt">ユーザー種類</dt>
      <dd class="profile__confirm__dd">{{ userTypeString }}</dd>
    </dl>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'RegistrationConfirmation',
  props: {
    profileData: Object,
  },
  computed: {
    birthDateString() {
      return moment(this.profileData.birthDate).format('YYYY-MM-DD');
    },
    userTypeString() {
      const typeToStrDictionary = {
        performer: 'パフォーマー',
        patron: 'パトロン', // その他はundefinedを期待
      };
      return typeToStrDictionary[this.profileData.userType];
    },
  }
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/signup-email.scss';
</style>
